import React from 'react'
import { Link } from 'react-router-dom'

import Button from '@material-ui/core/Button'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreHorizIcon from '@material-ui/icons/MoreHoriz'
import Logo from './logo.png'

export default function MobileNav () {
    const [anchorEl, setAnchorEl] = React.useState(null)

    const handleClick = event => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    const dropdownStyle = {
        fontSize: '70px',
        paddingLeft: '50px',
        paddingRight: '15px',
        paddingTop: '5px',
        paddingBottom: '5px'
    }
    const menuStyle = {
        backgroundColor: 'rgb(150, 208, 231)',
        zIndex: 574789379457398475938475938749857394875938795834853579837458345983745937859384789
    }
    const dropdownItemStyle = {
        textDecoration: 'none', 
        textAlign: 'center', 
        width: '100%',
    }
    return (
        <div className='t-nav-container'>
            <Link to='/' style={{ textDecoration: 'none' }} className='t-nav-brand-container'>
                <img src={Logo} alt='logo' className='t-nav-logo'/>
                <div className='t-nav-brand'>The Lot Broker</div>
            </Link>
            <div className='t-nav-dropdown'>
                <Button aria-controls='fade-menu' aria-haspopup='true' onClick={handleClick}>
                    <MoreHorizIcon style={dropdownStyle}/>
                </Button>
                <Menu
                    id='t-nav-menu'
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    style={{zIndex: 574789379457398475938475938749857394875938795834853579837458345983745937859384789}}
                    MenuListProps={{ disablePadding: true }}
                >
                    <MenuItem onClick={handleClose} style={menuStyle}>
                        <Link to='/about' style={dropdownItemStyle}>
                            <div className='t-nav-item'>About</div>
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose} style={menuStyle}>
                        <Link to='/gallery' style={dropdownItemStyle}>
                            <div className='t-nav-item'>Gallery</div>
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose} style={menuStyle}>
                        <Link to='/directors' style={dropdownItemStyle}>
                            <div className='t-nav-item'>Funeral Directors</div>
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose} style={menuStyle}>
                        <Link to='/inventory' style={dropdownItemStyle}>
                            <div className='t-nav-item'>Current Inventory</div>
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose} style={menuStyle}>
                        <Link to='/contact' style={dropdownItemStyle}>
                            <div className='t-nav-item'>Contact</div>
                        </Link>
                    </MenuItem>
                    <MenuItem onClick={handleClose} style={menuStyle}>
                        <Link to='/admin' style={dropdownItemStyle}>
                            <div className='t-nav-item'>Admin</div>
                        </Link>
                    </MenuItem>
                </Menu>
            </div>
      </div>
    )
}